import { render, staticRenderFns } from "./RespostaFinalTpl.vue?vue&type=template&id=79848028&"
import script from "./RespostaFinalTpl.vue?vue&type=script&lang=js&"
export * from "./RespostaFinalTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports